import { createAsyncThunk } from '@reduxjs/toolkit';

import CommonEnumsResource from 'api/service/CommonEnumsResource';
import PropertiesResource from 'api/service/PropertiesResource';
import ContributionsResource from 'api/service/ContributionsResource';

export const listContributorTypes = createAsyncThunk('reconciliation/listContributorTypes', async () => {
  const commonEnumsResource = new CommonEnumsResource();
  const { status, data } = await commonEnumsResource.list('contributor_type');
  if (status === 200) {
    return data;
  }
  return [];
});

export const listContributions = createAsyncThunk(
  'reconciliation/listContributions',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { propertyId } = initialData;
    const params = { size: 100 };
    const { status, data } = await propertiesResource.contribution(propertyId).list(params);
    if (status === 200) {
      return { propertyId, data };
    }
    return rejectWithValue({ propertyId, error: 'Contributions not found', data: [] });
  }
);

export const createContribution = createAsyncThunk(
  'reconciliation/createContribution',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { propertyId, payload } = initialData;
    const { status, data } = await propertiesResource.contribution(propertyId).create(payload);
    if (status === 201) {
      return data;
    }
    return rejectWithValue('Creating of Contribution failed.');
  }
);

export const updateContribution = createAsyncThunk(
  'reconciliation/updateContribution',
  async (initialData, { rejectWithValue }) => {
    const contributionsResource = new ContributionsResource();
    const { id, payload } = initialData;
    const { status, data } = await contributionsResource.contribution(id).update(payload);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Updating of Reconciliation failed.');
  }
);

export const deleteContribution = createAsyncThunk(
  'reconciliation/deleteContribution',
  async (initialData, { rejectWithValue }) => {
    const contributionsResource = new ContributionsResource();
    const { id, propertyId } = initialData;
    const response = await contributionsResource.contribution(id).delete();
    if (response.status === 202) {
      return { id, propertyId };
    }
    return rejectWithValue('Contribution not found');
  }
);
